import React from 'react';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { withRouter } from 'react-router';
import { Typography } from '@material-ui/core';

function MainMenu({ isDrawerOpen, toggleDrawer, history }) {
  const changePage = path => {
    history.push(path);
    toggleDrawer(false);
  };
  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      onClose={() => toggleDrawer(!isDrawerOpen)}
    >
      <List
        style={{
          width: '400px',
        }}
      >
        <ListItem button onClick={() => changePage('/parameters')}>
          <Typography variant="h6">Parameters</Typography>
        </ListItem>
        <ListItem button onClick={() => changePage('/therapeuticArea')}>
          <Typography variant="h6">Therapeutic Area</Typography>
        </ListItem>
      </List>
    </Drawer>
  );
}

export default withRouter(MainMenu);



// WEBPACK FOOTER //
// ./src/MainMenu.js